import { Box, Text } from "@mantine/core";
import { FORM_PATH_TO_CHANGES_KEY } from "./patientInfoFieldPaths";

interface PatientInfoFieldHintProps {
  formPath: string;
  changes?: Record<string, { before: unknown; after: unknown }>;
}

export default function PatientInfoFieldHint({
  formPath,
  changes,
}: PatientInfoFieldHintProps) {
  if (!changes) return null;
  const key = FORM_PATH_TO_CHANGES_KEY[formPath];
  const change = key ? changes[key] : undefined;
  if (!change) return null;
  const before = String(change.before ?? "");
  if (!before.replace(/<[^>]*>/g, "").trim()) return null;
  return (
    <Text size="xs" c="dimmed" mt={2}>
      {"Current: "}
      <Box
        component="span"
        className="rich-text-display"
        dangerouslySetInnerHTML={{ __html: before }}
        style={{ display: "inline" }}
      />
    </Text>
  );
}
